export default [
    {
        name: 'profileView',
        path: '/profile/view',
        component: require('@/pages/ProfileView').default,
        meta: {
            back: { label: 'Dashboard', to: '/' },
            security: (auth) => auth.can({ action: 'view', model: 'profile' })
        }
    },
    {
        name: 'profileEdit',
        path: '/profile/edit',
        component: require('@/pages/ProfileEdit').default,
        meta: {
            back: { label: 'My Profile', to: '/profile/view' },
            security: (auth) => auth.can({ action: 'edit', model: 'profile' })
        }
    },
    {
        name: 'profilePassword',
        path: '/profile/password',
        component: require('@/pages/ProfilePassword').default,
        meta: {
            back: { label: 'My Profile', to: '/profile/view' },
            security: (auth) => auth.can({ action: 'edit', model: 'profile' })
        }
    },
]
